import { camelizeKeys } from "humps";
import { StoreMetadata } from "@commons-monorepo/index";
import { AboutUsInformation } from "~/common/props/orchestrator";
export const mapAboutUsData = (
  storeMetadata: StoreMetadata,
  searchParams: URLSearchParams,
) => {
  const aboutUsData = {
    title: storeMetadata.catalogueAboutUs?.title || "",
    content: storeMetadata.catalogueAboutUs?.content || "",
    images: storeMetadata.catalogueAboutUs?.images || [],
  };

  const previewAboutUs = searchParams.get("about-us");
  if (previewAboutUs) {
    try {
      const previewAboutUsJson = camelizeKeys(
        JSON.parse(previewAboutUs),
      ) as AboutUsInformation;
      aboutUsData.title = previewAboutUsJson.title || "";
      aboutUsData.content = previewAboutUsJson.content || "";
      aboutUsData.images = previewAboutUsJson.images || [];
    } catch {}
  }

  return aboutUsData;
};
